import { AnalysisUserType } from "@models/platform-analysis/entities/analysis";
import { FieldGroup } from "@layouts/form/field-group";
import { SHDivider, SHStack } from "@components/design-systems";
import {
  AnalysisSetupDTO,
  SetupStepRenderSectionConfig as Section,
} from "@models/platform-analysis/entities/steps/setup";
import { useFormContext } from "react-hook-form";

type AnalysisSetupStepSectionProps = {
  section: Section;
  userType: AnalysisUserType;
  disabled?: boolean;
  showDivider?: boolean;
};

export const AnalysisSetupStepSection = ({
  section: {
    titles: { main: mainTitle, subTitle },
    fields,
    dependencyField,
  },
  userType,
  disabled,
  showDivider = true,
}: AnalysisSetupStepSectionProps) => {
  const { watch } = useFormContext<AnalysisSetupDTO>();
  const shouldRenderSection = !dependencyField || !!watch(dependencyField);

  if (!shouldRenderSection) return null;

  return (
    <>
      {showDivider && <SHDivider />}
      <FieldGroup title={mainTitle[userType]} subTitle={subTitle?.[userType]}>
        <SHStack
          spacing={3}
          direction="column"
          sx={{ width: { xs: "100%", md: 520 } }}
        >
          {fields?.map((field, index) => {
            const { showFor, renderComponent: RenderComponent } = field;
            if (!showFor.includes(userType)) return null;

            return (
              <RenderComponent
                key={index}
                userType={userType}
                disabled={disabled}
              />
            );
          })}
        </SHStack>
      </FieldGroup>
    </>
  );
};
